/**
 * Batch 23 — Small informational caption showing when the public Community
 * Impact figures were last published. Reads `updated_at` from the same
 * `/api/public/impact-stats` payload, so drafts never affect this date;
 * archived Impact Snapshot reports keep their original dates independently.
 *
 * The component intentionally does nothing when there are no stats loaded
 * yet, so it never causes a layout jump above the grid.
 */
function formatUpdated(stats) {
    const times = (stats || [])
        .map((s) => s?.updated_at)
        .filter(Boolean)
        .map((t) => Date.parse(t))
        .filter((t) => !Number.isNaN(t));
    if (times.length === 0) return "";
    const latest = new Date(Math.max(...times));
    try {
        // "29 July 2026" — human-friendly, locale-stable.
        return latest.toLocaleDateString("en-GB", {
            day: "numeric", month: "long", year: "numeric",
        });
    } catch {
        return latest.toISOString().slice(0, 10);
    }
}

export default function ImpactUpdatedCaption({ stats, tone = "light", testid = "impact-updated" }) {
    const label = formatUpdated(stats);
    if (!label) return null;
    // `tone="dark"` is used on the dark-green Home section; `tone="light"`
    // sits on white/soft backgrounds elsewhere. Both remain subtle grey.
    const cls = tone === "dark" ? "text-white/60" : "text-gray-500";
    return (
        <p
            className={`mt-6 text-xs sm:text-sm ${cls} text-center`}
            data-testid={testid}
        >
            Community Impact figures last updated:{" "}
            <time dateTime={label} data-testid={`${testid}-date`}>{label}</time>
        </p>
    );
}
